<div class="dropdown-simple">
  <ng-select [formControl]="control" [items]="data" bindLabel="label" #ngSelect class="simple">
    <ng-template ng-label-tmp let-item="item">
      <h5>{{ item.value }}</h5>
      <h6>{{ item.description }}</h6>
    </ng-template>
  </ng-select>
  <emt-delta-icon class="icon-arrow" (click)="toggle()" [flip]="open" iconName="icon-arrow-down-icon"></emt-delta-icon>
</div>
